import React, { useState, useEffect, useRef } from "react";

import { DownArrowIcon } from "../data-display/Icon";
import { cn } from "@/utils/index";
import { motion, AnimatePresence } from "framer-motion";
import Checkbox from "@/components/form/checkbox/Checkbox";

const FilterSection = ({
  name,
  selectedValue,
  isOpen,
  attributeList,
  onSelect,
  slug,
}) => {
  const [isFilterOpen, setIsFilterOpen] = useState(isOpen);
  const [isAnimating, setIsAnimating] = useState(false);
  const wasManuallyOpened = useRef(false);

  useEffect(() => {
    if (!wasManuallyOpened.current) {
      setIsFilterOpen(isOpen);
    }
  }, [isOpen]);

  function handelChange(data) {
    wasManuallyOpened.current = true;
    onSelect(data.value);
  }

  return (
    <div className="mb-4">
      <button
        onClick={() => setIsFilterOpen(!isFilterOpen)}
        className={cn(
          `flex w-full items-center justify-between  text-left font-medium py-[10px] px-[20px] bg-[#EBEEF2] `,
          isFilterOpen ? "rounded-t-xl" : "rounded-xl"
        )}
      >
        <span className={`text-lg font-medium text-grayD1 w-full line-clamp-1`}>
          {name}
        </span>
        <DownArrowIcon />
      </button>

      <AnimatePresence>
        {isFilterOpen && (
          <motion.div
            className="w-full bg-white border rounded-b-xl border-[#EBEEF2] max-h-[340px] overflow-y-auto filterScrollBar"
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: "auto" }}
            exit={{ opacity: 0, height: 0 }}
            onAnimationStart={() => setIsAnimating(true)}
            onAnimationComplete={() => setIsAnimating(false)}
            style={{ overflow: isAnimating ? "hidden" : "auto" }}
          >
            <div className="py-3 px-[20px]">
              <div className="">
                {[...attributeList].map((attribute) => (
                  <Checkbox
                    key={attribute.slug}
                    value={attribute.value}
                    slug={attribute.slug}
                    onChange={(e, data) => handelChange({ value: data })}
                    isChecked={selectedValue.includes(attribute.slug)}
                    id={slug + attribute.value}
                  />
                ))}
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default FilterSection;
